import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"
import { normalizeLocalReturnTo } from "@nova-ai/shared"

import { LoginCard } from "../components/auth/login-card"

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute("/login")({
  validateSearch: searchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.auth.user) {
      throw redirect({ to: normalizeLocalReturnTo(search.redirect, "/dashboard") })
    }
  },
  component: LoginPage,
})

function LoginPage() {
  const { redirect: redirectTo } = Route.useSearch()
  return <LoginCard redirectTo={redirectTo} />
}
